import { render } from "./StoricoOrdini.vue?vue&type=template&id=54b564da"
import script from "./StoricoOrdini.vue?vue&type=script&lang=js"
export * from "./StoricoOrdini.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__